import React, { useEffect, useState } from "react";
import LightGallery from "lightgallery/react";

import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

import PageTitle from "../../../layouts/PageTitle";

const Lightgallery = () => {

  const [gallery, setGallery] = useState([]);
  const [file, setFile] = useState(null);
  const [deleteId, setDeleteId] = useState(null); // ✅ for inline delete UI

  const [form, setForm] = useState({
    title: "",
    description: "",
  });

  useEffect(() => {
    fetchGallery();
  }, []);

  const fetchGallery = async () => {
    const res = await fetch("/backend/gallery");
    const data = await res.json();
    setGallery(data);
  };

  // ================= UPLOAD =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) return alert("Please select image");

    const formData = new FormData();
    formData.append("image", file);
    formData.append("title", form.title);
    formData.append("description", form.description);

    await fetch("/backend/gallery", {
      method: "POST",
      body: formData,
    });

    setFile(null);
    setForm({ title: "", description: "" });

    fetchGallery();
  };

  // ================= DELETE =================
  const handleDelete = async (id) => {
    await fetch(`/backend/gallery/${id}`, {
      method: "DELETE",
    });

    setDeleteId(null);
    fetchGallery();
  };

  return (
    <>
      <PageTitle activeMenu="Gallery" motherMenu="Dashboard" />

      <div className="row">

        {/* ================= UPLOAD ================= */}
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Upload Gallery Image</h4>
            </div>

            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className="row">

                  <div className="col-md-4">
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => setFile(e.target.files[0])}
                      required
                    />
                  </div>

                  <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Title"
                      className="form-control"
                      value={form.title}
                      onChange={(e) =>
                        setForm({ ...form, title: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-3">
                    <input
                      type="text"
                      placeholder="Description"
                      className="form-control"
                      value={form.description}
                      onChange={(e) =>
                        setForm({ ...form, description: e.target.value })
                      }
                    />
                  </div>

                  <div className="col-md-2">
                    <button className="btn btn-primary w-100">
                      Upload
                    </button>
                  </div>

                </div>
              </form>
            </div>
          </div>
        </div>

        {/* ================= GALLERY ================= */}
        <div className="col-lg-12">
          <div className="card">
            <div className="card-header">
              <h4 className="card-title">Gallery</h4>
            </div>

            <div className="card-body pb-1">

              {gallery.length === 0 ? (
                <p>No images found</p>
              ) : (

                <LightGallery
                  speed={500}
                  plugins={[lgThumbnail, lgZoom]}
                  elementClassNames="row"
                >

                  {gallery.map((item) => (
                    <div
                      key={item.id}
                      data-src={`/backend${item.image_url}`}
                      className="col-lg-3 col-md-6 mb-4"
                    >

                      <div className="position-relative">

                        {/* IMAGE */}
                        <img
                          src={`/backend${item.image_url}`}
                          alt={item.title}
                          className="rounded"
                          style={{
                            width: "100%",
                            height: "200px",
                            objectFit: "cover",
                          }}
                        />

                        {/* DELETE BUTTON */}
                        {deleteId !== item.id && (
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              setDeleteId(item.id);
                            }}
                            className="btn btn-danger btn-xs position-absolute"
                            style={{
                              top: "8px",
                              right: "8px",
                              padding: "5px 8px",
                            }}
                          >
                            ✕
                          </button>
                        )}

                        {/* ✅ INLINE CONFIRMATION */}
                        {deleteId === item.id && (
                          <div
                            className="position-absolute w-100 h-100 d-flex flex-column justify-content-center align-items-center"
                            style={{
                              top: 0,
                              left: 0,
                              background: "rgba(0,0,0,0.7)",
                              color: "#fff",
                              borderRadius: "8px",
                            }}
                          >
                            <p style={{ marginBottom: "10px" }}>
                              Delete this image?
                            </p>

                            <div>
                              <button
                                className="btn btn-sm btn-danger me-2"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDelete(item.id);
                                }}
                              >
                                Yes
                              </button>

                              <button
                                className="btn btn-sm btn-light"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(null);
                                }}
                              >
                                Cancel
                              </button>
                            </div>
                          </div>
                        )}

                      </div>

                      {/* TITLE */}
                      <div className="mt-2 text-center">
                        <strong>{item.title}</strong>
                        <p style={{ fontSize: "12px" }}>
                          {item.description}
                        </p>
                      </div>

                    </div>
                  ))}

                </LightGallery>

              )}

            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Lightgallery;